import { type DeviceResponseV5, deviceResponseV5StateEnum } from '@emma/api_client/types';
import { Flex, Text, Tooltip } from '@lego/klik-ui';
import { StatusCircleCheck, StatusInprogress } from '@lego/klik-ui/icons';
import { PlaceholderText } from '@/components/common/PlaceholderText';

type ReportedCoreVersionProps = {
  device: Pick<DeviceResponseV5, 'core' | 'state'>;
};

export const shouldShowReportedCoreVersionStatus = ({ state }: Pick<DeviceResponseV5, 'state'>) =>
  state === deviceResponseV5StateEnum.PROVISIONED;

export function ReportedCoreVersion({ device }: ReportedCoreVersionProps) {
  const reportedVersion = device.core.reportedVersion;
  const desiredVersion = device.core.desiredVersion;
  const shouldShowStatus = shouldShowReportedCoreVersionStatus(device);

  return (
    <Flex align="center">
      {reportedVersion != null ? (
        <Text fontFamily="mono" fontSize="sm">
          {reportedVersion}
        </Text>
      ) : (
        <PlaceholderText>Unknown</PlaceholderText>
      )}
      {!shouldShowStatus ? null : reportedVersion === desiredVersion ? (
        <Tooltip label="The device is running the desired core version.">
          <StatusCircleCheck boxSize={5} color="green" mb={0.5} ml={2} />
        </Tooltip>
      ) : (
        <Tooltip
          label={`The device is not running the desired core version. Desired: ${desiredVersion}`}
        >
          <StatusInprogress boxSize={5} color="grey" mb={0.5} ml={2} />
        </Tooltip>
      )}
    </Flex>
  );
}
